import type {
  PromptInputAttachment as PromptInputAttachmentData,
  PromptInputAttachmentInput,
  PromptInputAttachmentUploadBehavior,
  PromptInputFilePart,
} from './attachments'

export type PromptInputAttachment = PromptInputAttachmentData
export {
  PromptInputActionMenu,
  PromptInputActionMenuContent,
  PromptInputActionMenuItem,
  PromptInputActionMenuTrigger,
  PromptInputModelSelect,
  PromptInputModelSelectContent,
  PromptInputModelSelectItem,
  PromptInputModelSelectTrigger,
  PromptInputModelSelectValue,
  PromptInputSubmit,
} from '../prompt-input-extras'
export {
  PromptInputCommand,
  PromptInputCommandEmpty,
  PromptInputCommandGroup,
  PromptInputCommandInput,
  PromptInputCommandItem,
  PromptInputCommandList,
  PromptInputCommandSeparator,
  PromptInputHoverCard,
  PromptInputHoverCardContent,
  PromptInputHoverCardTrigger,
} from '../prompt-input-primitives'
export {
  PromptInputActionAddAttachments,
  type PromptInputActionAddAttachmentsProps,
  PromptInputActionMenuMobile,
  PromptInputAttachment,
  type PromptInputAttachmentProps,
  PromptInputAttachments,
  type PromptInputAttachmentsProps,
} from './attachment-components'
export type {
  AttachmentsContext,
  PromptInputAttachmentsState,
} from './attachments'
export { PromptInputDictationButton } from './dictation-button'
export {
  PromptInputBody,
  type PromptInputBodyProps,
  PromptInputButton,
  type PromptInputButtonProps,
  PromptInputFooter,
  type PromptInputFooterProps,
  PromptInputHeader,
  type PromptInputHeaderProps,
  PromptInputTextarea,
  type PromptInputTextareaProps,
  PromptInputTools,
  type PromptInputToolsProps,
} from './primitives'
export {
  PromptInput,
  type PromptInputMessage,
  type PromptInputProps,
} from './prompt-input'
export {
  type PromptInputControllerProps,
  type PromptInputMentionItem,
  PromptInputProvider,
  type PromptInputProviderProps,
  type TextInputContext,
  usePromptInputAttachments,
  usePromptInputController,
  useProviderAttachments,
} from './provider'
export type {
  PromptInputAttachmentInput,
  PromptInputAttachmentUploadBehavior,
  PromptInputFilePart,
}
